<template>
  <div id="app">

  <nav class="navbar rmg-header" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">Ready Made Go 3</router-link>

      <div class="navbar-burger burger" data-target="rmg-menu" v-on:click="showNav=!showNav" v-bind:class="{ 'is-active' : showNav}">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div id="rmg-menu" class="navbar-menu" v-bind:class="{ 'is-active' : showNav }">
      <div class="navbar-start">
          <router-link to="/audio-tour" v-on:click.native="hideNav" class="navbar-item">Audio Tour</router-link>
          <router-link to="/map" v-on:click.native="hideNav" class="navbar-item">Map</router-link>
          <router-link to="/70x40x50" v-on:click.native="hideNav" class="navbar-item">70 <sup>&times;</sup> 40 <sup>&times;</sup> 50</router-link>
          <router-link to="/plastic-primitive" v-on:click.native="hideNav" class="navbar-item">Plastic Primitive</router-link>
          <router-link to="/more" v-on:click.native="hideNav" class="navbar-item">More</router-link>
      </div>

      <div class="navbar-end">
        <p>Presented by</p>
        <img src="/static/img/rmg-mdr_logo.png" alt="Modern Design Review" class="mdr-logo">
      </div>
    </div>
  </nav>


    <section class="page columns">
      <router-view v-bind:soundcloud="soundcloud" v-bind:tracklist="tracklist" v-bind:exhibit="exhibit"></router-view>
    </section>

  <div class="rmg-footer"><p>Ace Hotel London &nbsp; 20-24 September 2017</p></div>

  </div><!-- /end #app -->
</template>

<script>
export default {
  name: 'app',
  props: ['soundcloud', 'tracklist', 'exhibit'],
  data () {
    return { showNav: false }
  },
  watch: {
    '$route': function () {
      // this.showNav = false
      this.soundcloud.api.pause()
    }
  },
  methods: {
    hideNav: function () {
      this.showNav = false
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue?130805ab